const initialState = {}

const actionTypes = {
  cacheData: 'cache/cacheData'
}

export const actionCreators = {
  cacheData: (key, data) => (
    { type: actionTypes.cacheData, key, data }
  )
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.cacheData:
      return { ...state, [action.key]: action.data }
    default: break
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/Cache.js